module.exports = __webpack_public_path__ + "static/media/Icon-Download.e3d52dc3.svg";